import type { PublicKeyCredentialCreationOptionsJSON } from '@simplewebauthn/browser'
import { http } from '../../config/axios'

const postUserPasskeyRegistroOptions = (): Promise<PublicKeyCredentialCreationOptionsJSON> => {
  return http
    .post('api/user/passkey/registro/options')
    .then((res) => {
      return res.data as PublicKeyCredentialCreationOptionsJSON
    })
    .catch((error) => {
      console.error('Erro postUserPasskeyRegistroOptions', error)
      throw Error(error.response?.data)
    })
}

export default postUserPasskeyRegistroOptions
